// Module
var code = `<!-- §6 CLOSER — RATIFIED (wording top-100 pass pending; copy of record 2026-08-13). No eyebrow by ruling. -->
<section class="landing-cta" aria-labelledby="landing-cta-headline">

    <div class="landing-cta__block">

        <div class="landing-cta__glow" aria-hidden="true"></div>

        <h2 id="landing-cta-headline" class="landing-cta__headline landing-headline"><span class="landing-eyebrow">OPEN SOURCE</span>
            SpyneJS is open source and free to use.
        </h2>

        <p class="landing-cta__sub">
            Everything on this page is available today. All of it is beta &mdash; 1.0 comes when the
            community has vetted it, not before.
        </p>

        <div class="cli-snippet">
            <div class="code-container">
                <code>npx spyne-cli create-app</code>
                <button type="button" aria-label="Copy command">⧉</button>
            </div>
        </div>

        <div class="landing-cta__links">
            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="docs"
                data-stage="examples"
                data-text="Docs"
                href="/docs/examples"
                class="landing-cta__link">Learn from Examples →</a>
            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="configure"
                href="/configure"
                class="landing-cta__link">Start with an Application Shell →</a>
            <a  target="_blank" href="https://github.com/spynejs" class="landing-cta__link">GitHub →</a>
        </div>

    </div>

</section>
`;
// Exports
module.exports = code;